/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface UserInfoSupervisorLocationContact { 
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    type: UserInfoSupervisorLocationContact.TypeEnum;
    /**
     * 
     */
    departmentId: number;
    /**
     * 
     */
    department: string;
    /**
     * 
     */
    locationId: string;
    /**
     * 
     */
    locationName: string;
    /**
     * 
     */
    startDate: string;
    /**
     * 
     */
    endDate?: string;
}
export namespace UserInfoSupervisorLocationContact {
    export type TypeEnum = 'internship-evaluation-interuniversity' | 'supervisor-quality-survey';
    export const TypeEnum = {
        InternshipEvaluationInteruniversity: 'internship-evaluation-interuniversity' as TypeEnum,
        SupervisorQualitySurvey: 'supervisor-quality-survey' as TypeEnum
    };
}


